import React, { Component } from 'react';
import { IonInput, IonHeader, IonButton, IonButtons, IonToolbar,
  IonSelectOption, IonContent, IonList, IonItem, IonSelect, IonItemDivider,
} from '@ionic/react';

type Props = {
  name: string,
  email: string,
  username: string,
  dismissModal: () => void;
  updateName: (name: string) => void;
}

type State = {
  username: string;
  email: string,
  name: string,
}

export default class EditUser extends Component<Props, State> {
  state = {
    username: '',
    email: '',
    name: '',
  }
  constructor(props: Props) {
    super(props);
    const { username, email, name } = this.props;
    this.state = {
      ...this.state,
      username,
      email,
      name,
    }
  }

  resetChanges = () => {
    const { username, email, name } = this.props;
    this.setState({
      ...this.state,
      username,
      email,
      name,
    });
    this.props.dismissModal();
  }

  applyChanges = () => {
    this.props.updateName(this.state.name);
    this.props.dismissModal();
  }

  handleNameChange = (e: CustomEvent) => {
    this.setState({
      ...this.state,
      name: e.detail.value,
    });
  }
  
  render() {
    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={this.props.dismissModal}>Cancel</IonButton>
            </IonButtons>
            <IonButtons slot="end">
              <IonButton onClick={this.applyChanges} strong>Save</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent class="outer-content">
          <IonList>
            <IonItem>
              <IonInput disabled value="kennrll18"></IonInput>
            </IonItem>

            <IonItemDivider>Input with clear button when there is a value</IonItemDivider>
            <IonItem>
              <IonInput value={this.state.name} onIonChange={this.handleNameChange} placeholder="Enter Input" clearInput></IonInput>
            </IonItem>

          </IonList>
          <IonList>
            <IonItem onClick={this.resetChanges} detail={false} class="reset-filters">
              <IonButton>Reset</IonButton>
            </IonItem>
          </IonList>
        </IonContent>
      </>
    );
  }
}
